/**
 * @Date:   2018-01-19T20:26:20+08:00
 * @Last modified time: 2018-02-28T16:30:17+08:00
 */

import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import { ConnectedRouter } from 'react-router-redux';
import { history } from "../store/store.js";
import User from "../routes/User/user.js";

import RoleControl from '../routes/SystemSetting/RoleControl';
import RoleManagement from '../routes/SystemSetting/RoleManagement.js';
// import RoleSetting from '../routes/SystemSetting/RoleSetting';
import SystemLogger from '../routes/SystemSetting/SystemLogger.js';
import UpdateLogger from '../routes/SystemSetting/UpdateLogger.js';
import Login from '../routes/Login/index.js';
import NotFound from '../routes/Exception/404.js';
import UserManagement from '../routes/SystemSetting/UserManagement.js';
import DepartmentStructure from '../routes/DepartmentStructure/DepartmentStructure.js';
import DepartmentDuty from '../routes/DepartmentStructure/DepartmentDuty';
// import RosterComponent from '../routes/EmployeeManagement/Roster.js';
import EmployeeComponent from '../routes/EmployeeManagement/Employee.js'
import EmployeeDetail from '../routes/EmployeeManagement/EmployeeDetail.js';

import EmployeeDetailEn from '../routes/EmployeeManagement/EmployeeDetailEn.js';



import DepartmentPosition from '../routes/DepartmentStructure/DepartmentPosition';
import AddressList from '../routes/EmployeeManagement/AddressList.js';
import AddressListEn from '../routes/EmployeeManagement/AddressListEn.js';
import CertificateManagement from '../routes/EmployeeManagement/CertificateManagement.js';
import ContractManagement from '../routes/EmployeeManagement/ContractManagement.js';
import ContractManagementDetail from '../routes/EmployeeManagement/ContractManagementDetail.js';
import StaffBirthday from '../routes/EmployeeManagement/StaffBirthday.js';
import MonthyReports from '../routes/EmployeeManagement/MonthyReport.js';
import MonthyReportsDetail from '../routes/EmployeeManagement/MonthyReportDetail.js';
import EmployeesReview from '../routes/EmployeeManagement/EmployeesReview.js';

// PC端Workreport
import DailyReport from '../routes/WorkReport/DailyReport.js';
import DailyReportEn from '../routes/WorkReport/DailyReportEn.js';
import WeeklyReport from '../routes/WorkReport/WeeklyReport.js';
import WeeklyReportEn from '../routes/WorkReport/WeeklyReportEn.js';
import MonthlyReport from '../routes/WorkReport/MonthlyReport.js';
import MonthlyReportEn from '../routes/WorkReport/MonthlyReportEn.js';
import WeeklyReportReview from '../routes/WorkReport/WeeklyReportReview.js';
import UserGroup from '../routes/DailyReport/UserGroup.js';
import UserGroup2 from '../routes/DailyReport/UserGroup2.js';
import GroupTemplateSetting from '../routes/DailyReport/GroupTemplateSetting.js';
import UserGroupDetail from '../routes/DailyReport/UserGroupDetail.js';
import DailyReportReview from '../routes/WorkReport/DailyReportReview.js';
import MonthlyReportReview from '../routes/WorkReport/MonthlyReportReview.js';
import TemplateManagement from '../routes/WorkReport/TemplateManagement';
import TemplateManagementDetail from '../routes/WorkReport/TemplateManagementDetail';
import WeeklyQuestionSummary from '../routes/WorkReport/WeeklyQuestionSummary.js';
import BestEmployeeStatistic from '../routes/WorkReport/BestEmployeeStatistic.js';
import DailyReportExceptionStatistics from '../routes/WorkReport/DailyReportExceptionStatistics.js';
import WorkReportExempt from '../routes/DailyReport/WorkReportExempt.js';

import AttendanceSchedule from '../routes/Attendance/AttendanceSchedule';
import AnnualLeave from '../routes/Attendance/AnnualLeave';
import AttendanceTemplate from '../routes/Attendance/AttendanceTemplate'
import CrewRostering from '../routes/Attendance/CrewRostering'
import AttendanceRecord from '../routes/Attendance/AttendanceRecord';
import AttendanceDailyRecord from '../routes/Attendance/AttendanceDailyRecord';
import AttendanceDailyRecordDetail from '../routes/Attendance/AttendanceDailyRecordDetail';
import AttendanceMonthlyRecord from '../routes/Attendance/AttendanceMonthlyRecord';
import AttendanceMonthlyRecordDetail from '../routes/Attendance/AttendanceMonthlyRecordDetail';
import LeaveManage from '../routes/Attendance/LeaveManage';
import OvertimeManage from '../routes/Attendance/OvertimeManage'
import ResultsReport from '../routes/Attendance/ResultsReport'
import AttendanceYearlyRecord from '../routes/Attendance/AttendanceYearlyRecord';
import AttendanceYearlyRecordDetail from '../routes/Attendance/AttendanceYearlyRecordDetail';
import CompanyCalendar from "../routes/Attendance/CompanyCalendar";
import VacationManagement from "../routes/Attendance/VacationManagement";
import EmployeeIncentiveLeave from "../routes/Attendance/employee-incentive-leave";
import AttendanceCheckInOutRecord from '../routes/Attendance/AttendanceCheckInOutRecord';
import AttendanceClockInRecord from '../routes/Attendance/AttendanceClockInRecord';
import AttendanceNoCheckInOutRecord from '../routes/Attendance/AttendanceNoCheckInOutRecord';
import AttendanceAmendRelaxationRecord from '../routes/Attendance/AttendanceAmendRelaxation';

import CourseLibrary from "../routes/Training/CourseLibrary";
import InternalCourse from "../routes/Training/InternalCourse";
import ExternalCourse from "../routes/Training/ExternalCourse";
import NewcomerTraining from "../routes/Training/NewcomerTraining";
import TraningGroup from "../routes/Training/TraningGroup";

import HiringManagement from "../routes/Recruitment/HiringManagement";
import InterviewManagement from "../routes/Recruitment/InterviewManagement";
import NotificationTemplate from "../routes/Recruitment/NotificationTemplate";
import RecruitmentRequirement from "../routes/Recruitment/RecruitmentRequirement";
import RecruitmentSetting from "../routes/Recruitment/RecruitmentSetting";
import RecruitmentStatistics from "../routes/Recruitment/RecruitmentStatistics";
import ResumeLibrary from "../routes/Recruitment/ResumeLibrary";

// 薪资
import AirticketAllowance from "../routes/SalaryAllowance/AirticketAllowance";
import EmployeeInsurance from "../routes/SalaryAllowance/EmployeeInsurance";
import HousingAllowance from "../routes/SalaryAllowance/HousingAllowance";
import InsuranceLedger from "../routes/SalaryAllowance/InsuranceLedger";
import InsuranceLedgerDetail from "../routes/SalaryAllowance/InsuranceLedgerDetail";
import InsuranceManagement from "../routes/SalaryAllowance/InsuranceManagement";
import SalaryHistory from "../routes/SalaryAllowance/SalaryHistory";
import SalaryLedger from "../routes/SalaryAllowance/SalaryLedger";
import SalaryLedgerDetail from "../routes/SalaryAllowance/SalaryLedgerDetail";
import SalaryManagement from "../routes/SalaryAllowance/SalaryManagement";
import SalaryWater from "../routes/SalaryAllowance/SalaryWater";
import AttendanceSummary from "../routes/SalaryAllowance/AttendanceSummary";
import SalaryAddition from "../routes/SalaryAllowance/SalaryAddition";



// 审批
import ComplainApproval from "../routes/Approval/ComplainApproval";
import DayoffApproval from "../routes/Approval/DayoffApproval";
import GooutApproval from "../routes/Approval/GooutApproval";
import BusinessApproval from "../routes/Approval/BusinessApproval";
import LeaveApproval from "../routes/Approval/LeaveApproval";
import OvertimeApproval from "../routes/Approval/OvertimeApproval";
import PendingApproval from "../routes/Approval/PendingApproval";
import ApprovalAccess from "../routes/Approval/ApprovalAccess";
import ApprovalWorkflow from "../routes/Approval/ApprovalWorkflow";

//公告制度
import AnnouncementList from "../routes/Announcement/AnnouncementList";
import AnnouncementListEn from "../routes/Announcement/AnnouncementListEn";

// 员工端PC端
import EmployeeHome from "../routes/Employee/EmployeeHome";
import EmployeeHomeEn from "../routes/Employee/EmployeeHomeEn";
import ApplicationCenter from "../routes/Employee/ApplicationCenter";
import ApplicationCenterEn from "../routes/Employee/ApplicationCenterEn";
import ApprovalCenter from "../routes/Employee/ApprovalCenter";
import ApprovalCenterEn from "../routes/Employee/ApprovalCenterEn";
import MyAttendance from "../routes/Employee/MyAttendance";
import MyAttendanceEn from "../routes/Employee/MyAttendanceEn";
import AppCenter from "../routes/Employee/AppCenter";
import AppCenterEn from "../routes/Employee/AppCenterEn";

import MyAttendanceDetail from "../routes/Employee/MyAttendanceDetail";

import ApplyOvertime from "../routes/Employee/ApplyOvertime";
import ApplyBreakDown from "../routes/Employee/ApplyBreakDown";
import ApplySpecialBreakDown from "../routes/Employee/ApplySpecialBreakDown";
import ApplyLeave from "../routes/Employee/ApplyLeave";
import ChangePassword from "../routes/Employee/ChangePassword";
import ChangeSecondPassword from "../routes/Employee/ChangeSecondPassword";
import ApplyAnnualLeave from "../routes/Employee/ApplyAnnualLeave";
import ApplyGoOut from "../routes/Employee/ApplyGoOut";
import ApplyAttendance from "../routes/Employee/ApplyAttendance";
import ApplyBusiness from "../routes/Employee/ApplyBusiness";

import PersonalCenter from "../routes/Employee/PersonalCenter";
import PersonalCenterEn from "../routes/Employee/PersonalCenterEn";
import MySalary from "../routes/Employee/MySalary";
import MySalaryEn from "../routes/Employee/MySalaryEn";

// 员工端移动端
import MobileHome from "../routes/Mobile/MobileHome";
import MobileApplicationCenter from "../routes/Mobile/MobileApplicationCenter";


import MobileApplyOvertime from "../routes/Mobile/MobileApplyOvertime";
import MobileApplyOvertimeList from "../routes/Mobile/MobileApplyOvertimeList";
import MobileApplyOvertimeDetail from "../routes/Mobile/MobileApplyOvertimeDetail";

import MobileApplyBreakDownCreate from "../routes/Mobile/MobileApplyBreakDownCreate";
import MobileApplyBreakDownList from "../routes/Mobile/MobileApplyBreakDownList";
import MobileApplyBreakDownDetail from "../routes/Mobile/MobileApplyBreakDownDetail";


import MobileApplyLeaveList from "../routes/Mobile/MobileApplyLeaveList";
import MobileApplyLeaveDetail from "../routes/Mobile/MobileApplyLeaveDetail";
import MobileApplyLeaveCreate from "../routes/Mobile/MobileApplyLeaveCreate";

import MobileApplyBusinessList from "../routes/Mobile/MobileApplyBusinessList";
import MobileApplyBusinessCreate from "../routes/Mobile/MobileApplyBusinessCreate";
import MobileApplyBusinessDetail from "../routes/Mobile/MobileApplyBusinessDetail";


import MobileApplyGoOutList from "../routes/Mobile/MobileApplyGoOutList";
import MobileApplyGoOutDetail from "../routes/Mobile/MobileApplyGoOutDetail";
import MobileApplyGoOutCreate from "../routes/Mobile/MobileApplyGoOutCreate";


import MobileMySalaryList from "../routes/Mobile/MobileMySalaryList";
import MobileMySalaryDetail from "../routes/Mobile/MobileMySalaryDetail";

import MobileApproval from "../routes/Mobile/MobileApproval";
import MobileApprovalCenter from "../routes/Mobile/MobileApprovalCenter";
import MobileApprovalOvertimeList from "../routes/Mobile/MobileApprovalOvertimeList";
import MobileApprovalDayoffList from "../routes/Mobile/MobileApprovalDayoffList";
import MobileApprovalComplainList from "../routes/Mobile/MobileApprovalComplainList";
import MobileApprovalLeaveList from "../routes/Mobile/MobileApprovalLeaveList";
import MobileApprovalGooutList from "../routes/Mobile/MobileApprovalGooutList";
import MobileApprovalBusinessList from "../routes/Mobile/MobileApprovalBusinessList";
import MobileApprovalContent from "../routes/Mobile/MobileApprovalContent";

import MobileAppCenter from "../routes/Mobile/MobileAppCenter";
import MobileCalendar from "../routes/Mobile/MobileCalendar";
import MobileAttendanceDetail from "../routes/Mobile/MobileAttendanceDetail";
import MobileAnnouncement from "../routes/Mobile/MobileAnnouncement";
import MobileAnnouncementDetail from "../routes/Mobile/MobileAnnouncementDetail";
import MobileMyDailyReport from '../routes/Mobile/MobileMyDailyReport.js';
import MobileMyDailyReportDetail from '../routes/Mobile/MobileMyDailyReportDetail.js';
import MobileMyWeeklyReport from '../routes/Mobile/MobileMyWeeklyReport.js';
import MobileMyWeeklyReportDetail from '../routes/Mobile/MobileMyWeeklyReportDetail.js';
import MobileMyMonthlyReport from '../routes/Mobile/MobileMyMonthlyReport.js';
import MobileMyMonthlyReportDetail from '../routes/Mobile/MobileMyMonthlyReportDetail.js';


class AppRouter extends Component {

       render() {
              return (
                     <ConnectedRouter history={history}>
                            <LocaleProvider locale={zh_CN}>
                                   <Switch>
                                          <Route exact path="/user"
                                                 component={User} />
                                          <Route exact path="/"
                                                 render={() => <Redirect to="/login" />} />
                                          <Route exact path="/login"
                                                 component={Login} />
                                          {/* 系统管理 */}
                                          <Route exact path="/setting/role-management"
                                                 component={RoleManagement} />
                                          <Route exact path="/setting/role-setting"
                                                 component={RoleControl} />
                                          <Route exact path="/setting/user-management"
                                                 component={UserManagement} />
                                          <Route exact path="/setting/system-logger"
                                                 component={SystemLogger} />
                                          <Route exact path="/setting/update-log"
                                                 component={UpdateLogger} />
                                          {/* 组织架构 */}
                                          <Route exact path="/department/department-structure"
                                                 component={DepartmentStructure} />
                                          <Route exact path="/department/department-duty"
                                                 component={DepartmentDuty} />
                                          <Route exact path="/department/department-position"
                                                 component={DepartmentPosition} />
                                          {/* 员工管理 */}
                                          <Route exact path="/employee/roster"
                                                 component={EmployeeComponent} />



                                          <Route exact path="/employee/detail"
                                                 component={EmployeeDetail} />
                                          <Route exact path="/employee/detail/:id"
                                                 component={EmployeeDetail} />

                                          <Route exact path="/employee/detail-en/:id"
                                                 component={EmployeeDetailEn} />





                                          <Route exact path="/employee/address-list"
                                                 component={AddressList} />
                                          <Route exact path="/employee/address-list-en"
                                                 component={AddressListEn} />
                                          <Route exact path="/employee/certificate-management"
                                                 component={CertificateManagement} />
                                          <Route exact path="/employee/contract-management"
                                                 component={ContractManagement} />
                                          <Route exact path="/employee/contract-management/:employee_id"
                                                 component={ContractManagementDetail} />
                                          <Route exact path="/employee/birthday-list"
                                                 component={StaffBirthday} />
                                          <Route exact path="/employee/monthy-report"
                                                 component={MonthyReports} />
                                          <Route exact path="/employee/monthy-report-detail/:date"
                                                 component={MonthyReportsDetail} />
                                          <Route exact path="/employee/employees-review/:type"
                                                 component={EmployeesReview} />
                                          {/* 日周月报 */}
                                          <Route exact path="/report/my-daily-report"
                                                 component={DailyReport} />
                                          <Route exact path="/report/my-daily-report-en"
                                                 component={DailyReport} />
                                          <Route exact path="/report/my-daily-report/:currentModalStatus"
                                                 component={DailyReport} />
                                          <Route exact path="/report/daily-report-review"
                                                 component={DailyReportReview} />

                                          <Route exact path="/report/my-weekly-report"
                                                 component={WeeklyReport} />
                                          <Route exact path="/report/my-weekly-report-en"
                                                 component={WeeklyReport} />
                                          <Route exact path="/report/my-weekly-report/:currentModalStatus"
                                                 component={WeeklyReport} />

                                          <Route exact path="/report/question-summary"
                                                 component={WeeklyQuestionSummary} />
                                          <Route exact path="/report/question-summary/:currentModalStatus"
                                                 component={WeeklyQuestionSummary} />

                                          <Route exact path="/report/my-monthly-report"
                                                 component={MonthlyReport} />
                                          <Route exact path="/report/my-monthly-report-en"
                                                 component={MonthlyReport} />
                                          <Route exact path="/report/my-monthly-report/:currentModalStatus"
                                                 component={MonthlyReport} />
                                          <Route exact path="/report/weekly-report-review"
                                                 component={WeeklyReportReview} />
                                          <Route exact path="/report/user-group"
                                                 component={UserGroup} />
                                          <Route exact path="/report/user-group2"
                                                 component={UserGroup2} />
                                          <Route exact path="/report/group-template"
                                                 component={GroupTemplateSetting} />
                                          <Route exact path="/report/user-group/:department_id"
                                                 component={UserGroupDetail} />
                                          <Route exact path="/report/monthly-report-review"
                                                 component={MonthlyReportReview} />
                                          <Route exact path="/report/template-management"
                                                 component={TemplateManagement} />
                                          <Route exact path="/report/template-management/:id"
                                                 component={TemplateManagementDetail} />
                                          <Route exact path="/report/best-employee-statistic"
                                                 component={BestEmployeeStatistic} />
                                          <Route exact path="/report/daily-reportrexception-statistics"
                                                 component={DailyReportExceptionStatistics} />
                                          <Route exact path="/report/work-report-exempt"
                                                 component={WorkReportExempt} />

                                          {/* 考勤管理 */}
                                          <Route exact path="/attendance/attendance-schedule"
                                                 component={AttendanceSchedule} />
                                          <Route exact path="/attendance/attendance-template"
                                                 component={AttendanceTemplate} />
                                          <Route exact path="/attendance/crew-rostering"
                                                 component={CrewRostering} />
                                          <Route exact path="/attendance/annual-leave"
                                                 component={AnnualLeave} />
                                          <Route exact path="/attendance/attendance-record"
                                                 component={AttendanceRecord} />
                                          <Route exact path="/attendance/attendance-daily-record"
                                                 component={AttendanceDailyRecord} />
                                          <Route exact path="/attendance/attendance-daily-record-detail/:date"
                                                 component={AttendanceDailyRecordDetail} />

                                          <Route exact path="/attendance/attendance-monthly-record"
                                                 component={AttendanceMonthlyRecord} />
                                          <Route exact path="/attendance/attendance-monthly-record-detail/:employee_id/:date/:name/:department"
                                                 component={AttendanceMonthlyRecordDetail} />

                                          <Route exact path="/attendance/attendance-yearly-record"
                                                 component={AttendanceYearlyRecord} />
                                          <Route exact path="/attendance/attendance-yearly-record-detail/:employee_id/:date/:name/:department"
                                                 component={AttendanceYearlyRecordDetail} />

                                          <Route exact path="/attendance/checkinoutrecords-management"
                                                 component={AttendanceCheckInOutRecord} />

                                          <Route exact path="/attendance/clockinrecords-management"
                                                 component={AttendanceClockInRecord} />

                                          <Route exact path="/attendance/nocheckinoutrecords-management"
                                                 component={AttendanceNoCheckInOutRecord} />

                                          <Route exact path="/attendance/amendrelaxation-management"
                                                 component={AttendanceAmendRelaxationRecord} />

                                          <Route exact path="/attendance/vacation-management"
                                                 component={VacationManagement} />
                                          <Route exact path="/attendance/employee-incentive-leave"
                                                 component={EmployeeIncentiveLeave} />
                                          <Route exact path="/attendance/company-calendar"
                                                 component={CompanyCalendar} />
                                          <Route exact path="/attendance/leave-management"
                                                 component={LeaveManage} />
                                          <Route exact path="/attendance/overtime-management"
                                                 component={OvertimeManage} />
                                          <Route exact path="/attendance/results-report"
                                                 component={ResultsReport} />
                                          {/* 培训管理 */}
                                          <Route exact path="/training/course-library"
                                                 component={CourseLibrary} />
                                          <Route exact path="/training/internal-course"
                                                 component={InternalCourse} />
                                          <Route exact path="/training/external-course"
                                                 component={ExternalCourse} />
                                          <Route exact path="/training/newcomer-training"
                                                 component={NewcomerTraining} />
                                          <Route exact path="/training/tranning-group"
                                                 component={TraningGroup} />
                                          {/* 招聘管理 */}
                                          <Route exact path="/recruitment/hiring-management"
                                                 component={HiringManagement} />
                                          <Route exact path="/recruitment/resume-library"
                                                 component={ResumeLibrary} />
                                          <Route exact path="/recruitment/interview-management"
                                                 component={InterviewManagement} />
                                          <Route exact path="/recruitment/recruitment-requirement"
                                                 component={RecruitmentRequirement} />
                                          <Route exact path="/recruitment/recruitment-statistics"
                                                 component={RecruitmentStatistics} />
                                          <Route exact path="/recruitment/notification-template"
                                                 component={NotificationTemplate} />
                                          <Route exact path="/recruitment/recruitment-setting"
                                                 component={RecruitmentSetting} />
                                          {/* 薪资管理 */}
                                          <Route exact path="/salary-allowance/airticket-allowance"
                                                 component={AirticketAllowance} />
                                          <Route exact path="/salary-allowance/employee-insurance"
                                                 component={EmployeeInsurance} />
                                          <Route exact path="/salary-allowance/housing-allowance"
                                                 component={HousingAllowance} />
                                          <Route exact path="/salary-allowance/insurance-ledger"
                                                 component={InsuranceLedger} />
                                          <Route exact path="/salary-allowance/insurance-ledger/:id"
                                                 component={InsuranceLedgerDetail} />
                                          <Route exact path="/salary-allowance/insurance-management"
                                                 component={InsuranceManagement} />
                                          <Route exact path="/salary-allowance/salary-history"
                                                 component={SalaryHistory} />
                                          <Route exact path="/salary-allowance/salary-ledger"
                                                 component={SalaryLedger} />
                                          <Route exact path="/salary-allowance/salary-ledger/:id"
                                                 component={SalaryLedgerDetail} />
                                          <Route exact path="/salary-allowance/salary-management"
                                                 component={SalaryManagement} />
                                          <Route exact path="/salary-allowance/salary-water"
                                                 component={SalaryWater} />
                                          <Route exact path="/salary-allowance/attendance-summary"
                                                 component={AttendanceSummary} />
                                            <Route exact path="/salary-allowance/salary-addition/:id"
                                                 component={SalaryAddition} />
                                          {/* 审批中心 */}
                                          <Route exact path="/approval/complain-approval"
                                                 component={ComplainApproval} />
                                          <Route exact path="/approval/dayoff-approval"
                                                 component={DayoffApproval} />
                                          <Route exact path="/approval/goout-approval"
                                                 component={GooutApproval} />
                                          <Route exact path="/approval/business-approval"
                                                 component={BusinessApproval} />
                                          <Route exact path="/approval/leave-approval"
                                                 component={LeaveApproval} />
                                          <Route exact path="/approval/overtime-approval"
                                                 component={OvertimeApproval} />
                                          <Route exact path="/approval/pending-approval"
                                                 component={PendingApproval} />
                                          <Route exact path="/approval/approval-access"
                                                 component={ApprovalAccess} />
                                          <Route exact path="/approval/approval-workflow"
                                                 component={ApprovalWorkflow} />

                                          {/* 公告制度 */}
                                          <Route exact path="/announcement/announcement-list"
                                                 component={AnnouncementList} />

                                          {/* 员工端PC端*/}
                                          <Route exact path="/employee/employee-home"
                                                 component={EmployeeHome} />
                                          <Route exact path="/employee/employee-home-en"
                                                 component={EmployeeHomeEn} />
                                          <Route exact path="/employee/application-center"
                                                 component={ApplicationCenter} />
                                          <Route exact path="/employee/application-center-en"
                                                 component={ApplicationCenter} />
                                          <Route exact path="/employee/approval-center"
                                                 component={ApprovalCenter} />
                                          <Route exact path="/employee/approval-center-en"
                                                 component={ApprovalCenter} />
                                          <Route exact path="/employee/my-attendance"
                                                 component={MyAttendance} />
                                          <Route exact path="/employee/my-attendance-en"
                                                 component={MyAttendance} />
                                          <Route exact path="/employee/my-attendance-detail/:management_date"
                                                 component={MyAttendanceDetail} />
                                          <Route exact path="/employee/app-center"
                                                 component={AppCenter} />
                                          <Route exact path="/employee/app-center-en"
                                                 component={AppCenterEn} />
                                          <Route exact path="/employee/apply-overtime"
                                                 component={ApplyOvertime} />
                                          <Route exact path="/employee/apply-break-down"
                                                 component={ApplyBreakDown} />
                                          <Route exact path="/employee/apply-special-break-down"
                                                 component={ApplySpecialBreakDown} />
                                          <Route exact path="/employee/apply-leave"
                                                 component={ApplyLeave} />
                                          <Route exact path="/employee/apply-annual-leave"
                                                 component={ApplyAnnualLeave} />
                                          <Route exact path="/employee/apply-go-out"
                                                 component={ApplyGoOut} />
                                          <Route exact path="/employee/apply-attendance"
                                                 component={ApplyAttendance} />
                                          <Route exact path="/employee/apply-business"
                                                 component={ApplyBusiness} />
                                          <Route exact path="/employee/personal-center"
                                                 component={PersonalCenter} />
                                          <Route exact path="/employee/personal-center-en"
                                                 component={PersonalCenterEn} />
                                          <Route exact path="/employee/my-salary"
                                                 component={MySalary} />
                                          <Route exact path="/employee/my-salary-en"
                                                 component={MySalary} />
                                          <Route exact path="/employee/announcement"
                                                 component={AnnouncementList} />
                                          <Route exact path="/employee/announcement-en"
                                                 component={AnnouncementListEn} />
                                          <Route exact path="/employee/change-password"
                                                 component={ChangePassword} />
                                          <Route exact path="/employee/change-second-password"
                                                 component={ChangeSecondPassword} />


                                          {/* Mobile*/}
                                          <Route exact path="/mobile/home"
                                                 component={MobileHome} />
                                          <Route exact path="/mobile/mobile-application-center"
                                                 component={MobileApplicationCenter} />
                                          <Route exact path="/mobile/mobile-apply-overtime"
                                                 component={MobileApplyOvertime} />
                                          <Route exact path="/mobile/mobile-apply-overtime-list"
                                                 component={MobileApplyOvertimeList} />
                                          <Route exact path="/mobile/mobile-apply-overtime-detail"
                                                 component={MobileApplyOvertimeDetail} />


                                          <Route exact path="/mobile/mobile-apply-break-down-create"
                                                 component={MobileApplyBreakDownCreate} />
                                          <Route exact path="/mobile/mobile-apply-break-down-list"
                                                 component={MobileApplyBreakDownList} />
                                          <Route exact path="/mobile/mobile-apply-break-down-detail"
                                                 component={MobileApplyBreakDownDetail} />


                                          <Route exact path="/mobile/mobile-apply-leave-list"
                                                 component={MobileApplyLeaveList} />
                                          <Route exact path="/mobile/mobile-apply-leave-detail"
                                                 component={MobileApplyLeaveDetail} />
                                          <Route exact path="/mobile/mobile-apply-leave-create"
                                                 component={MobileApplyLeaveCreate} />


                                          <Route exact path="/mobile/mobile-apply-business-list"
                                                 component={MobileApplyBusinessList} />
                                          <Route exact path="/mobile/mobile-apply-business-create"
                                                 component={MobileApplyBusinessCreate} />
                                          <Route exact path="/mobile/mobile-apply-business-detail"
                                                 component={MobileApplyBusinessDetail} />

                                          <Route exact path="/mobile/mobile-apply-go-out-list"
                                                 component={MobileApplyGoOutList} />
                                          <Route exact path="/mobile/mobile-apply-go-out-detail"
                                                 component={MobileApplyGoOutDetail} />
                                          <Route exact path="/mobile/mobile-apply-go-out-create"
                                                 component={MobileApplyGoOutCreate} />

                                          <Route exact path="/mobile/mobile-my-salary-list"
                                                 component={MobileMySalaryList} />
                                          <Route exact path="/mobile/mobile-my-salary-detail"
                                                 component={MobileMySalaryDetail} />



                                          <Route exact path="/mobile/mobile-approval-center"
                                                 component={MobileApprovalCenter} />
                                          <Route exact path="/mobile/mobile-approval"
                                                 component={MobileApproval} />
                                          <Route exact path="/mobile/mobile-approval-overtime-list"
                                                 component={MobileApprovalOvertimeList} />
                                          <Route exact path="/mobile/mobile-approval-dayoff-list"
                                                 component={MobileApprovalDayoffList} />
                                          <Route exact path="/mobile/mobile-approval-business-list"
                                                 component={MobileApprovalBusinessList} />
                                          <Route exact path="/mobile/mobile-approval-leave-list"
                                                 component={MobileApprovalLeaveList} />
                                          <Route exact path="/mobile/mobile-approval-goout-list"
                                                 component={MobileApprovalGooutList} />
                                          <Route exact path="/mobile/mobile-approval-complain-list"
                                                 component={MobileApprovalComplainList} />

                                          <Route exact path="/mobile/mobile-approval-content"
                                                 component={MobileApprovalContent} />

                                          <Route exact path="/mobile/mobile-app-center"
                                                 component={MobileAppCenter} />
                                          <Route exact path="/mobile/mobile-calendar"
                                                 component={MobileCalendar} />
                                          <Route exact path="/mobile/mobile-attendance-detail"
                                                 component={MobileAttendanceDetail} />
                                          <Route exact path="/mobile/mobile-announcement"
                                                 component={MobileAnnouncement} />
                                          <Route exact path="/mobile/mobile-announcement-detail"
                                                 component={MobileAnnouncementDetail} />

                                          <Route exact path="/mobile/mobile-my-daily-report"
                                                 component={MobileMyDailyReport} />
                                          <Route exact path="/mobile/mobile-my-daily-report-detail"
                                                 component={MobileMyDailyReportDetail} />
                                          <Route exact path="/mobile/mobile-my-weekly-report"
                                                 component={MobileMyWeeklyReport} />
                                          <Route exact path="/mobile/mobile-my-weekly-report-detail"
                                                 component={MobileMyWeeklyReportDetail} />
                                          <Route exact path="/mobile/mobile-my-monthly-report"
                                                 component={MobileMyMonthlyReport} />
                                          <Route exact path="/mobile/mobile-my-monthly-report-detail"
                                                 component={MobileMyMonthlyReportDetail} />

                                          {/* 404 */}
                                          <Route component={NotFound} path="/404" />
                                   </Switch>
                            </LocaleProvider>
                     </ConnectedRouter>
              )
       }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/router/index.js